import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Collapse from 'react-css-collapse';

import { ReactComponent as ArrowDown } from '../../images/icons/chevron-down.svg';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './Accordion.module.css';

const Accordion = ({ items = [], numbered = false, defaultCollapsed = false, className = '' }) => {
  const [open, setOpen] = useState(defaultCollapsed ? [] : [0]);
  const onClick = (i) => {
    if (open.indexOf(i) > -1) {
      setOpen([...open.filter((key) => key !== i)]);
    } else {
      setOpen([...open, i]);
    }
  };

  return (
    <div className={[className].join(' ')}>
      {items.map((item, k) => {
        const isOpen = open.indexOf(k) > -1;
        let copy = item.supportingText || item.body;
        return (
          /*eslint-disable-next-line*/
          <div className={styles.wrap} key={k} onClick={() => onClick(k)}>
            <div className={styles.toggle}>
              <h4>
                {numbered && <span className={styles.numbered}>{String(k + 1).padStart(2, '0')}</span>}
                {item.title}
              </h4>
              <ArrowDown className={isOpen ? styles.flip : ''} />
            </div>
            <Collapse className={styles.collapser} isOpen={open.indexOf(k) > -1}>
              <div id={`faq-${k}`} className={styles.copy}>
                {copy?.raw && <RichTextConverter copy={copy} />}
                {!copy?.raw && <div dangerouslySetInnerHTML={{ __html: copy }} />}
              </div>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
};

Accordion.propTypes = {
  items: PropTypes.array.isRequired,
};

export default Accordion;
